import { render, staticRenderFns } from "./mail-modal.vue?vue&type=template&id=30df95ba&scoped=true"
import script from "./mail-modal.vue?vue&type=script&lang=js"
export * from "./mail-modal.vue?vue&type=script&lang=js"
import style0 from "./mail-modal.vue?vue&type=style&index=0&id=30df95ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30df95ba",
  null
  
)

export default component.exports